// frontend/js/login.js
// ==========================================
import '../scss/login.scss';
// ==========================================
(function () {

    function loginPage() {
        const that = this;
        const _mgr = new function () {};  // 你要放管理用變數、設定，都可以

        const REGULAR_EMAIL = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
        const REGULAR_PASSWORD = /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/;

        // ---------------------------
        // 區塊：負責組 HTML 字串
        // ---------------------------
        that.BuildHTML = new function () {
        };

        // ---------------------------
        // 區塊：通用工具
        // ---------------------------
        that.CommonFunction = new function () {
            this.onEventListener = function(el, evt, sel, handler) {
                el.addEventListener(evt, function(event) {
                    let t = event.target;
                    while (t && t !== this) {
                        if (t.matches(sel)) {
                            handler.call(t, event);
                        }
                        t = t.parentNode;
                    }
                });
            };
            this.getParents = function(elem, selector) {
                if (!Element.prototype.matches) {
                    Element.prototype.matches =
                        Element.prototype.matchesSelector ||
                        Element.prototype.mozMatchesSelector ||
                        Element.prototype.msMatchesSelector ||
                        Element.prototype.oMatchesSelector ||
                        Element.prototype.webkitMatchesSelector ||
                        function(s) {
                            const matches = (this.document || this.ownerDocument).querySelectorAll(s);
                            let i = matches.length;
                            while (--i >= 0 && matches.item(i) !== this) {}
                            return i > -1;
                        };
                }

                for (; elem && elem !== document; elem = elem.parentNode) {
                    if (elem.matches(selector)) return elem;
                }
                return null;
            };
            this.formatPriceNumber = function(strNumber) {
                if (typeof strNumber === 'number') {
                    strNumber = Math.ceil(strNumber).toString();
                } else {
                    strNumber = Math.ceil(Number(strNumber)).toString();
                }

                for (let i = strNumber.length - 3; i > 0; i -= 3) {
                    strNumber = strNumber.substring(0, i) + ',' + strNumber.substring(i);
                }
                return strNumber;
            };
        };

        // ---------------------------
        // 區塊：實際業務邏輯
        // ---------------------------
        that.doFunction = new function () {
        };

        // ---------------------------
        // 區塊：初始化流程
        // ---------------------------
        that.initFunction = new function () {

            this.init = async function () {
                console.log('　'.repeat(120));
                console.log('='.repeat(120));
                console.log('MainPage init...AA');
            };

            this.initRegisterEvent = function () {
                that.CommonFunction.onEventListener(document, 'click', '.page-login .el-button-submit', async function(event) {
                    event.stopPropagation();
                    event.preventDefault();

                    let submitOK = true;
                    let DOM_target = event.target;

                    if(DOM_target.classList.contains('active')) {
                        submitOK = false;
                        return false;
                    }

                    const DOM_input_email = document.querySelector('input[name="email"]');
                    const DOM_input_email_invalidMsg = DOM_input_email.closest('.field')?.querySelector('.invalidMsg');

                    const DOM_input_password = document.querySelector('input[name="password"]');
                    const DOM_input_password_invalidMsg = DOM_input_password.closest('.field')?.querySelector('.invalidMsg');

                    // 檢查 email
                    if(DOM_input_email.value.trim() == '') {
                        DOM_input_email.classList.add('invalid');
                        DOM_input_email_invalidMsg.innerText = '請輸入E-mail';
                        DOM_input_email_invalidMsg.style.display = 'block';
                        submitOK = false;
                        return false;
                    }
                    else {

                        if (!REGULAR_EMAIL.test(DOM_input_email.value)) {
                            DOM_input_email.classList.add('invalid');
                            DOM_input_email_invalidMsg.innerText = '請輸入正確E-mail格式';
                            DOM_input_email_invalidMsg.style.display = 'block';
                            submitOK = false;
                            return false;
                        }
                        else {
                            DOM_input_email.classList.remove('invalid');
                            DOM_input_email_invalidMsg.style.display = 'none';
                        }
                    }

                    // 檢查 password
                    if(DOM_input_password.value.trim() == '') {
                        DOM_input_password.classList.add('invalid');
                        DOM_input_password_invalidMsg.innerText = '請輸入密碼';
                        DOM_input_password_invalidMsg.style.display = 'block';
                        submitOK = false;
                        return false;
                    }
                    else {
                        if(DOM_input_password.value.length >= 6 && DOM_input_password.value.length <= 16) {
                            if(!REGULAR_PASSWORD.test(DOM_input_password.value)) {
                                DOM_input_password.classList.add('invalid');
                                DOM_input_password_invalidMsg.innerText = '密碼格式不正確，請重新輸入';
                                DOM_input_password_invalidMsg.style.display = 'block';
                                submitOK = false;
                                return false;
                            }
                            else {
                                DOM_input_password.classList.remove('invalid');
                                DOM_input_password_invalidMsg.style.display = 'none';
                            }
                        }
                        else {
                            DOM_input_password.classList.add('invalid');
                            DOM_input_password_invalidMsg.innerText = '密碼格式不正確，請重新輸入';
                            DOM_input_password_invalidMsg.style.display = 'block';
                            submitOK = false;
                            return false;
                        }
                    }

                    if(submitOK && !DOM_target.classList.contains('active')) {

                        // const form = document.querySelector('#loginForm');
                        // ✅ 驗證 OK，交給瀏覽器送 form
                        // form.submit();
                        // return false;


                        DOM_target.classList.add('active');
                        document.body.classList.add('process');

                        var ref = {
                            'email': DOM_input_email.value,
                            'password': DOM_input_password.value
                        };

                        var form_data = new FormData();
                        for ( var key in ref ) {
                            form_data.append(key, ref[key]);
                        }

                        try {
                            const res = await fetch('/login', {
                                method: 'POST',
                                credentials: 'same-origin',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                    'CSRF-Token': csrfToken
                                },
                                body: new URLSearchParams({
                                    email: DOM_input_email.value.trim(),
                                    password: DOM_input_password.value.trim()
                                }),
                                cache: 'no-store'
                            });

                            // ✅ 只 parse 一次
                            const jsonData = await res.json();

                            // ✅ 失敗：顯示後端 message（你可以改成塞到 invalidMsg）
                            if (!res.ok || !jsonData.success) {
                                throw new Error(jsonData.message || '登入失敗');
                            }

                            // ✅ 成功導頁
                            location.href = jsonData.redirectTo || '/';

                        } catch (err) {
                            console.log('POST /login err：', err);
                            alert(err.message || '登入失敗');
                            DOM_target.classList.remove('active');
                            document.body.classList.remove('process');
                        }

                    }

                });

                that.CommonFunction.onEventListener(document, 'keypress', '.page-login', function(event) {
                    if (event.keyCode == 13) {
                        console.log('click enter');
                        const DOM_button_submit = document.querySelector('.page-login button[type="submit"]');
                        DOM_button_submit.click();
                    }
                });

                document.querySelector('input[name="email"]').addEventListener('input', (event) => {
                    event.stopPropagation();
                    event.preventDefault();

                    const DOM_input_email = document.querySelector('input[name="email"]');
                    const DOM_input_email_invalidMsg = DOM_input_email.closest('.field')?.querySelector('.invalidMsg');

                    if(DOM_input_email.classList.contains('invalid')) {
                        if(DOM_input_email.value.trim() == '') {
                            DOM_input_email.classList.add('invalid');
                            DOM_input_email_invalidMsg.innerText = '請輸入E-mail';
                            DOM_input_email_invalidMsg.style.display = 'block';
                        }
                        else {
                            if (!REGULAR_EMAIL.test(DOM_input_email.value)) {
                                DOM_input_email.classList.add('invalid');
                                DOM_input_email_invalidMsg.innerText = '請輸入正確E-mail格式';
                                DOM_input_email_invalidMsg.style.display = 'block';
                                return false;
                            }
                            else {
                                DOM_input_email.classList.remove('invalid');
                                DOM_input_email_invalidMsg.style.display = 'none';
                            }
                        }
                    }
                });

                document.querySelector('input[name="password"]').addEventListener('input', (event) => {
                    event.stopPropagation();
                    event.preventDefault();

                    const DOM_input_password = document.querySelector('input[name="password"]');
                    const DOM_input_password_invalidMsg = DOM_input_password.closest('.field')?.querySelector('.invalidMsg');

                    if(DOM_input_password.classList.contains('invalid')) {
                        if(DOM_input_password.value.trim() == '') {
                            DOM_input_password.classList.add('invalid');
                            DOM_input_password_invalidMsg.innerText = '請輸入密碼';
                            DOM_input_password_invalidMsg.style.display = 'block';
                            return false;
                        }
                        else {
                            if(DOM_input_password.value.length >= 6 && DOM_input_password.value.length <= 16) {
                                if(!REGULAR_PASSWORD.test(DOM_input_password.value)) {
                                    DOM_input_password.classList.add('invalid');
                                    DOM_input_password_invalidMsg.innerText = '密碼格式不正確，請重新輸入';
                                    DOM_input_password_invalidMsg.style.display = 'block';
                                    return false;
                                }
                                else {
                                    DOM_input_password.classList.remove('invalid');
                                    DOM_input_password_invalidMsg.style.display = 'none';
                                }
                            }
                            else {
                                DOM_input_password.classList.add('invalid');
                                DOM_input_password_invalidMsg.innerText = '密碼格式不正確，請重新輸入';
                                DOM_input_password_invalidMsg.style.display = 'block';
                                return false;
                            }
                        }
                    }

                });

                that.CommonFunction.onEventListener(document, 'click', '.password-visibility', function(event) {
                    event.stopPropagation();
                    event.preventDefault();

                    if(event.target.classList.contains('close')) {
                        event.target.src = '/images/visibility.svg';
                        event.target.classList.remove('close');
                        event.target.classList.add('open');

                        event.target.nextElementSibling .type = 'text';
                    }
                    else {
                        event.target.src = '/images/visibility_off.svg';
                        event.target.classList.remove('open');
                        event.target.classList.add('close');

                        event.target.nextElementSibling .type = 'password';
                    }
                });

                that.CommonFunction.onEventListener(document, 'click', '.el-button-forgotPW', function(event) {
                    event.stopPropagation();
                    event.preventDefault();

                    location.href = '/forgetpwd';
                });

                that.CommonFunction.onEventListener(document, 'click', '.el-button-register', function(event) {
                    event.stopPropagation();
                    event.preventDefault();

                    location.href = '/register';
                });
            };
        };
    }

    // ==========================================
    // ✅ 5. 等 window load 再啟動 MainPage
    // ==========================================
    window.addEventListener('load', function () {
        const loginPageManager = new loginPage();
        loginPageManager.initFunction.initRegisterEvent();
        loginPageManager.initFunction.init();
    });

})();
